export var DanceRole;
(function (DanceRole) {
    DanceRole["Leader"] = "Leader";
    DanceRole["Follower"] = "Follower";
})(DanceRole || (DanceRole = {}));
export const DANCE_ROLES = Object.values(DanceRole);
export const TIME_SPENT_DANCING = [
    'Brand new',
    'Under 2 months',
    '2 - 6 months',
    'Over 6 months',
    'Over 2 years',
    'Over 5 years',
];
//# sourceMappingURL=user-prompt.schema.js.map